import React from 'react';

interface CloseIconProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

const CloseIcon: React.FC<CloseIconProps> = ({ size = 20, className = "", onClick }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 20 20" 
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path 
        d="M15 5L5 15M5 5L15 15" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CloseIcon;